import { getGroupedConstructionPlanMedia } from '../../utils';

export const getMediaFormData = (site, referenceData, resolvedMedia) => {
    return getGroupedConstructionPlanMedia(site, referenceData, resolvedMedia, true);
};
